module.exports = {
  appEnv : "production",
  backendUrl: "https://app.kyubi.io/api/",
  baseUrl: "https://app.kyubi.io",
  };
